<!-- eslint-disable max-len -->
<template>
  <div>
    <!-- <j-title-header :options="title"/> -->
    <div class="component-card-report m__t--50">
      <label class="label-report">Total Siswa</label>
      <j-bar-chart-js
        v-if="showReportTotalSiswa"
        :datacollection="datacollectionSiswa"
        :options="optionsSiswa" />

      <v-client-table
        :data="data_table"
        :columns="columns"
        :options="options"
        class="jTable" />
        <!-- <jLoadingTable v-if="!load_first"/> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import jApiKurikulum from '@/services/jApiKurikulum';
// import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  components: {
    // jLoadingTable,
  },
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Report Pegawai',
      },
      load_first: false,
      data_table: [],
      columns: ['laki_laki', 'perempuan', 'pindah', 'keluar', 'lulus'],
      options: {
        headings: {
          laki_laki: 'Laki-Laki',
          perempuan: 'Perempuan',
          pindah: 'PINDAH',
          keluar: 'KELUAR',
          lulus: 'LULUS',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 10,
        perPageValues: [10, 50, 100],
      },

      showReportTotalSiswa: false,
      datacollectionSiswa: {
        labels: [],
        datasets: [],
      },
      optionsSiswa: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display: true,
            },
          }],
          xAxes: [{
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display: true,
            },
          }],
        },
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
      },
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
    this.totalSiswa();
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),

    async totalSiswa() {
      const getList = await jApiKurikulum.getTotalSiswa();
      const values = Object.values(getList.data.data);
      this.datacollectionSiswa.labels = Object.keys(getList.data.data).map(el => el.replace('_', ' ').toUpperCase());
      this.datacollectionSiswa.datasets = [
        {
          label: 'Jumlah',
          backgroundColor: '#1392ff',
          data: values,
        },
      ];
      this.showReportTotalSiswa = true;
      this.data_table = [getList.data.data];
    },
  },
  validations() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kesiswaan/siswa/jSiswaReport.vue